import { Component, OnInit, ViewChild, ElementRef, OnDestroy, Input } from '@angular/core';
import { NavParams } from '@ionic/angular';

import { SAMService } from 'src/app/sam/sam.service';
import { SAM } from 'src/app/sam/base/sam';
import { CartService } from 'src/app/services/cart.service';
import { SAMMessage } from 'src/app/sam/interfaces/sam-message';
import { ThemeService } from 'ngx-elvis-ds';
import { BasePage, Helpers } from 'ngx-elvis-ds';

export class KeyboardDialogCommands {
  public static OPEN = ['OPEN_KEYBOARD', 'kbd.open'];
  public static UPDATE_OSD = ['SET_KBD_OSD', 'kbd.osd.update'];
  public static UPDATE_SETTINGS = 'SET_KBD_SETTINGS';
  public static CLOSE = ['CLOSE_KEYBOARD', 'kbd.close'];
}

@Component({
  selector: 'app-keyboard-dialog',
  templateUrl: './keyboard-dialog.page.html',
  styleUrls: ['./keyboard-dialog.page.scss'],
})
export class KeyboardDialogPage extends BasePage implements OnInit, OnDestroy {

  @ViewChild('keyboard', { static: true }) keyboard: ElementRef;
  @Input() data: any;
  currentSam: SAMService | SAM;
  osdValue: String;

  constructor(
    private navParams: NavParams,
    public themeSvc: ThemeService,
    private sam: SAMService,
    private cartSvc: CartService,
  ) {
    super();
    this.setCurrentSam();
    this.subscribeListeners();
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.initKeyboard);
    this.unsubscribeListeners();
  }

  onCallback(key) {
    if (!this.data.disabled && !key.disabled && !key.blank) {
      const message: any = {
        Command: key.callback,
        Val: key.value,
        parms: {}
      };

      if (key.callback === 'VK_LOOKUP') { message.parms.Qty = this.cartSvc.counters.qty; }

      this.currentSam.onSend(message);
    }
  }

  onDismiss() {
    if (!this.data.dismissable) {
      this.currentSam.onSend({
        Command: this.data.closeCommand || 'USER_CLOSE_KEYBOARD',
        Val: null,
        parms: {}
      });
    }
  }

  ngOnInit() {
    this.data.keysFlat = Helpers.flatten(this.data.keys);
  }

  // private

  private initKeyboard = (evt: any) => {
    const event = evt || window.event;
    let isEscape, isBackspace, isEnter;

    if ('key' in event) {
      isEscape = (event.key === 'Escape' || event.key === 'Esc');
      isBackspace = (event.key === 'Backspace' || event.key === 'Delete');
      isEnter = (event.key === 'Enter');
    } else {
      isEscape = (event.keyCode === 27);
    }
    if (isEscape) {
      this.onDismiss();
    } else if (isBackspace) {
      const key = this.data.keysFlat.find(k => k.callback === 'DELETE_ONE');
      if (key) { this.onCallback(key); }
    } else if (isEnter) {
      const key = this.data.keysFlat.find(k => k.callback === 'VK_LOOKUP');
      if (key) { this.onCallback(key); }
    } else {
      const key = this.data.keysFlat.find(k => k.value === event.key && k.callback === 'APPEND');
      if (key) { this.onCallback(key); }
    }

    return false;
  }

  private subscribeListeners() {
    this.subscriptions.keyboard = this.sam.channels.dialogs.subscribe((msg: SAMMessage) => {
      if (KeyboardDialogCommands.UPDATE_OSD.includes(msg.Command)) {
        const data: any = msg.parms;
        this.osdValue = data.value.toString();
      }

      if (msg.Command === KeyboardDialogCommands.UPDATE_SETTINGS) {
        const data: any = msg.parms;
        this.data.draggable = data.draggable || true;
        this.data.disabled = data.disabled || false;
        this.data.keys = data.keys;
        this.data.keysFlat = Helpers.flatten(this.data.keys);
      }
    });

    document.addEventListener('keydown', this.initKeyboard);
  }

  private unsubscribeListeners() {
    document.onkeydown = null;
    if (this.subscriptions.keyboard) { this.subscriptions.keyboard.unsubscribe(); }
  }

  private setCurrentSam() {
    if (this.navParams.get('childSam')) {
      this.currentSam = this.navParams.get('childSam');
    } else {
      this.currentSam = this.sam;
    }
  }

}
